export type BillingLimit = {
  code: string;
  message: string;
  details?: Record<string, unknown>;
};

const UPGRADE_CODES = new Set([
  'saved_recipe_limit',
  'chef_turn_limit',
  'monthly_chef_turn_limit',
  'ai_credit_limit',
  'schedules_unavailable',
  'webhooks_unavailable',
  'active_recipe_limit',
  'recipe_plan_suspended',
  'manual_execution_limit',
  'automatic_execution_unavailable',
  'execution_frequency_limit',
  'schedule_frequency_limit',
  'runtime_limit',
]);

export const billingLimitFromData = (data: any): BillingLimit | null => {
  if (!data?.code || !UPGRADE_CODES.has(data.code)) return null;
  return {
    code: data.code,
    message: data.message || data.error || 'Choose a plan to keep using Kitchen.',
    details: data.details,
  };
};

export const billingLimitFromError = (error: any): BillingLimit | null =>
  billingLimitFromData(error?.response?.data);

export const billingLimitTitle = (code: string): string => {
  if (code === 'saved_recipe_limit') return 'Ready for another recipe?';
  if (code === 'chef_turn_limit' || code === 'monthly_chef_turn_limit') return 'Keep cooking with Chef';
  if (code === 'schedules_unavailable' || code === 'automatic_execution_unavailable') return 'Put this recipe on autopilot';
  if (code === 'webhooks_unavailable') return 'Let Kitchen respond automatically';
  if (code === 'active_recipe_limit' || code === 'recipe_plan_suspended') return 'Your kitchen is full';
  if (code === 'execution_frequency_limit') return 'This recipe ran recently';
  if (code === 'schedule_frequency_limit') return 'Choose a schedule that fits';
  if (code === 'runtime_limit' || code === 'ai_credit_limit') return 'Keep your recipes cooking';
  return 'Ready to keep cooking?';
};

export const billingLimitDismissLabel = (code: string): string =>
  code === 'schedule_frequency_limit' ? 'Change timing' : 'Maybe later';
